module.exports = __webpack_public_path__ + "img/img-verre.cac81cf8.svg";